/** Bound retained course data during prerender; one course can have twelve interfaces. */
export class SnapshotCache extends Map {
  constructor(limit = 16) {
    super();
    if (!Number.isInteger(limit) || limit < 1) throw new RangeError('Snapshot cache limit must be positive');
    this.limit = limit;
  }

  get(key) {
    const value = super.get(key);
    if (super.has(key)) {
      super.delete(key);
      super.set(key, value);
    }
    return value;
  }

  set(key, value) {
    super.delete(key);
    super.set(key, value);
    while (this.size > this.limit) super.delete(this.keys().next().value);
    return this;
  }
}
